<template>
  <div class="container">
    <div v-if="!accepted">
      <h3 class="title">
        Czy możesz zrobić zdjęcie
        <br />tabliczki znamionowej sprzętu?
      </h3>
      <div class="btn-group">
        <button
          type="button"
          class="btn gray"
          :style="{ background: $color }"
          @click="setAssistanceStep('additional')"
        >NIE</button>
        <button
          type="button"
          class="btn"
          :style="{ background: $color }"
          @click="accepted = true"
        >TAK</button>
      </div>
    </div>
    <div v-else>
      <h3 class="title">
        Prześlij zdjęcie tabliczki znamionowej sprzętu.
        <br />Aby to zrobić, skorzystaj z opcji "szybki aparat" lub galeria.
      </h3>
      <div class="btn-group">
        <label class="btn full" :style="{ background: $color }" @click="accepted = true">
          Prześlij zdjęcie
          <input
            type="file"
            name="photo"
            accept="image/*"
            ref="files"
            class="hidden"
            @change="uploadHandler"
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
export default {
  name: "StepHomeRepairPhoto",
  data() {
    return {
      accepted: false,
    };
  },
  methods: {
    ...mapMutations(["setUserData", "setAssistanceStep"]),
    ...mapActions(["sendPhoto", "createClaim"]),
    uploadHandler() {
      const uploadedFile = this.$refs.files.files[0];
      const formData = new FormData();
      formData.append("url", uploadedFile);
      this.sendPhoto(formData).then((res) => {
        this.setUserData({ PhotoUrl: res.data.url });
        this.setAssistanceStep("additional");
      });
    },
  },
};
</script>

<style scoped lang="scss">
.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepHomeRepairPhoto.vue